exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timeline-event-treatment__title{font-size:15px;font-weight:700}.timeline-event-treatment__subtitle{margin-top:15px;font-size:12px;font-weight:500}.timeline-event-treatment__text{font-size:14px;font-weight:500}.timeline-event-treatment__text p{margin-bottom:8px}.timeline-event-treatment__text p:last-child{margin-bottom:0}", ""]);

// exports
